import { PageHeader, Screen } from '@/shared/ui/Layout'
import { PageHeroSkeleton } from '@/shared/ui/Skeleton'

import { MissionAboutCard } from './components/show/MissionAboutCard'
import { MissionEvidenceSection } from './components/show/MissionEvidenceSection'
import { MissionRewardCard } from './components/show/MissionRewardCard'
import { MissionShowEmpty } from './components/show/MissionShowEmpty'
import { MissionShowHero } from './components/show/MissionShowHero'
import { MissionShowSkeleton } from './components/show/MissionShowSkeleton'
import { MissionStatusCard } from './components/show/MissionStatusCard'
import { MissionTimeline } from './components/show/MissionTimeline'
import { useMissionShow } from './hooks/useMissionShow'

export const DigitalProductMission = ({ id }) => {
  const {
    mission,
    isLoading,
    humanName,
    timeStatus,
    showStatus,
    statusHint,
    showTimeline,
    capacity,
    capacityStatus,
    hasParticipantRestriction,
    totalParticipants,
    isCapacityFull,
    submission,
    wallet,
    form,
    isSubmitting,
    isReadonly,
    showEvidenceForm,
    showAutoComplete,
    canResubmit,
    handleSubmitContent,
    handleOpenCamera,
    navigateBack
  } = useMissionShow(id)

  if (isLoading) {
    return (
      <Screen>
        <Screen.Context>
          <PageHeader
            title={humanName.singular}
            backHref="/missoes"
          />
          <PageHeroSkeleton className="mb-0" />
        </Screen.Context>
        <Screen.Content className="pt-2">
          <MissionShowSkeleton />
        </Screen.Content>
      </Screen>
    )
  }

  if (!mission) {
    return (
      <Screen>
        <Screen.Context>
          <PageHeader
            title={humanName.singular}
            backHref="/missoes"
          />
        </Screen.Context>
        <Screen.Content className="pt-2">
          <MissionShowEmpty onBack={navigateBack} />
        </Screen.Content>
      </Screen>
    )
  }

  return (
    <Screen>
      <Screen.Context>
        <PageHeader
          title={humanName.singular}
          backHref="/missoes"
        />
        <MissionShowHero mission={mission} showStatus={showStatus} />
      </Screen.Context>

      <Screen.Content className="flex flex-col gap-0 pt-2">
        <MissionStatusCard
          showStatus={showStatus}
          statusHint={statusHint}
          totalParticipants={totalParticipants}
          hasParticipantRestriction={hasParticipantRestriction}
          capacityStatusLabel={
            capacity?.status?.label || capacityStatus?.name
          }
          isCapacityFull={isCapacityFull}
          startAt={mission.start_at}
          endAt={mission.end_at}
          timeSlug={timeStatus?.slug}
        />

        <MissionAboutCard
          description={mission.description}
          evidenceKind={mission.evidence_kind}
          confirmationRequired={mission.confirmation_required}
        />

        <MissionEvidenceSection
          mission={mission}
          showStatus={showStatus}
          submission={submission}
          form={form}
          isSubmitting={isSubmitting}
          isReadonly={isReadonly}
          showEvidenceForm={showEvidenceForm}
          showAutoComplete={showAutoComplete}
          canResubmit={canResubmit}
          isCapacityFull={isCapacityFull}
          onSubmit={handleSubmitContent}
          onOpenCamera={handleOpenCamera}
        />

        {showTimeline && <MissionTimeline showStatus={showStatus} />}

        {showStatus === 'approved' && (
          <MissionRewardCard
            pointReward={mission.point_reward}
            coinReward={mission.coin_reward}
            walletPoints={wallet?.points}
            walletCoins={wallet?.coins}
          />
        )}
      </Screen.Content>
    </Screen>
  )
}
